import React, { useState, useEffect } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import PageHeader from '../../../components/PageHeader/PageHeader';

const SalaryChangeReport = (props) => {
    //Data оноох функц
    const [data, setData] = useState([]);

    //Багана оноох функц
    const [columns] = useState([{
        name: 'Ажилтны нэр',
        fieldName: 'empfirstname',
        ColSize: 'small'
    }, {
        name: 'Албан тушаал',
        fieldName: 'positionname',
        ColSize: 'small'
    }, {
        name: 'Дотоод нэгж',
        fieldName: 'departmentname',
        minColSize: 'mid'
    }, {
        name: 'Хуулийн этгээд',
        fieldName: 'companyname',
        ColSize: 'small'
    },
    {
        name: 'Тушаалын дугаар',
        fieldName: 'orderno'
    }, {
        name: 'Даатгуулагчийн төрөл',
        fieldName: 'insuretypeid',
        minColSize: 'mid'
    }, {
        name: 'Дотоод нэгж',
        fieldName: 'depid',
        minColSize: 'mid'
    }, {
        name: 'Эхэлсэн огноо',
        fieldName: 'begindate'
    }, {
        name: 'Дууссан огноо',
        fieldName: 'enddate'
    },
    {
        name: 'Үндсэн цалин',
        fieldName: 'basewage'
    }, {
        name: 'Хөдөлмөрийн нөхцөл',
        fieldName: 'labourcondition'
    }, {
        name: 'Хүйс',
        fieldName: 'empgendername'
    }]);

    const [loading, setLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        let tData = [];
        tData = [];
        setData(tData);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onGridFilterChange = async (p_gridfiltervalue) => {
        getData(p_gridfiltervalue);
    }

    return (
        <div>
            <PageHeader
                title='Цалинд өөрчлөлт орсон'
                columns={columns}
                data={data}
                filteredData={data}
                onSearch={onSearch}
                gridFilter={[]}
                dataCount={data.length}
                onGridFilterChange={onGridFilterChange}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default SalaryChangeReport;